import './js/_global'
import './js/_functions'
import './js/_utils'

// Elements.
import './js/elements/_navbar.js'

// Feeds.
import './js/feeds/_faq.js'; import './js/feeds/_training-date.js'

// Pages.
import './js/pages/_calendar.js'; import './js/pages/_faq-category.js'; import './js/pages/_maritime-professions.js'; import './js/pages/_posts.js'; import './js/pages/_trainings.js'

// Parts.
import './js/parts/_notification.js'

// Shortcodes.
import './js/shortcodes/_contact-form.js'; import './js/shortcodes/_registration-form.js'

// Blocks.
import './js/blocks/_gallery.js'; import './js/blocks/_guide.js'; import './js/blocks/_maritime-professions.js'; import './js/blocks/_reviews.js'

// Singles.
import './js/singles/_post.js'; import './js/singles/_training.js'
